import { useEffect, useRef } from 'react';
import useEventmessageSend from 'modules/queries/eventmessage/useEventmessageSend';
import sendGtmEvent from 'utility/gtm/sendGtmEvent';

interface TriggerServerViewEventParams {
	uniqId: string;
}

// custom reusable hook to trigger server-view gtm event & event message api
const useTriggerServerViewEvent = ({
	uniqId,
}: TriggerServerViewEventParams) => {
	const gtmEventTriggered = useRef(false);
	const { mutate: sendEventMessage } = useEventmessageSend();

	useEffect(() => {
		// trigger gtm event only once
		if (gtmEventTriggered.current) return;
		gtmEventTriggered.current = true;
		sendGtmEvent({
			event: 'lw.event',
			eventName: 'service.details_viewed',
			eventData: {
				server_id: uniqId,
				timestamp: new Date().toISOString(),
				system: 'lw',
			},
		});
		sendEventMessage({
			event_type: 'service.details_viewed',
			pld: { uniq_id: uniqId },
		});
	}, [sendEventMessage, uniqId, gtmEventTriggered]);
};

export default useTriggerServerViewEvent;
